export const NOT_FOUND_PAGE = 'https://common.hkjc.com/maint/404.aspx';